import { store } from '~system/store/configure-store';

export const getActiveScope = () => store.getState().scope.scope;
